/* src/app/shared/components/no-network/no-network.component.scss */
.no-network {
  margin: 80px auto;
  width: 30%;
  min-width: 360px;
}
.no-network > div {
  text-align: center;
  padding: 10px;
  font-size: 16px;
}
.no-network > div > .no-network-header {
  color: #033a6a;
  margin-bottom: 1.5rem;
}
.no-network > div > .no-network-header > i {
  font-size: 3rem;
}
.no-network > div > .no-network-header > h3 {
  margin-top: 1rem;
}
/*# sourceMappingURL=no-network.component.css.map */
